<template>
  <div>
    <v-container>
      <v-row class="elevation-1">
        <v-col cols="6">
          <v-select
            label="Large File Imports "
            id="input-text-size"
            class="input-text-size"
            v-model="select"
            :items="items"
            item-text="name"
            item-value="value"
            @change="handleSelectionChange"
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-select
           label="Additional Script for legacy"
            id="input-text-size"
            class="input-text-size"
            v-model="scripts"
            :items="additionalScripts"
            item-text="name"
            item-value="value"
            @change="()=>handleAdditionalScripts(scripts)"
          ></v-select>
        </v-col>
      </v-row>

      <!-- <v-row class="elevation-1">

      </v-row> -->

      <v-row class="text-center">
        <v-col cols="2">
          <v-checkbox
           class="input-text-size"
            v-model="writeConcern"
            color="primary"
            label="Write Concern"
            value="1"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="2">
          <v-btn
            color="primary"
            small
            :loading="isStartingImport"
            :disabled="isImporting || isBusy"
            @click="sendCollectionValue"
          >Import Data</v-btn>
        </v-col>
        <v-col cols="3">
            <v-btn color="warning" small class="input-text-size"
            :disabled="isImporting || isBusy"
            @click="truncateCollection"
            >Truncate Temp</v-btn>
           </v-col>

        <v-col cols="3">
            <v-btn color="info" small class="input-text-size"
            :loading="isRunningScript"
            :disabled="isImporting || isBusy"
            @click="handleScript"
            >Additional Script</v-btn>
           </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col cols="12">
          <h3>update gross in payments</h3>
          <v-text-field
            v-model.number="gross.taxYear"
            label="Enter tax year"
            class="input-text-size"
          ></v-text-field>
          <v-text-field
            v-model.number="gross.month"
            label="Enter month"
            class="input-text-size"
          ></v-text-field>
          <v-btn color="primary" small @click="updateGross">Update Gross</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="scriptResult || scriptError">
        <v-col cols="12">
          <v-alert
            v-if="scriptResult"
            type="success"
            outlined
            dense
          >
            {{ scriptResult.message }}
            <div v-if="scriptResult.count !== null && scriptResult.count !== undefined">
              Total records processed: {{ scriptResult.count }}
            </div>
          </v-alert>
          <v-alert
            v-if="scriptError"
            type="error"
            outlined
            dense
          >
            {{ scriptError }}
          </v-alert>
        </v-col>
      </v-row>
      <circularProgressBar :isThereAnError="isThereAnError"
      :value="totalImported" :totalRecords="totalRecords" :isImporting="isImporting"/>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import '../../assets/style.css';
// import axios from 'axios';
import circularProgressBar from '../common/circularProgressBar.vue';

export default {
  name: 'importStatus',
  components: {
    circularProgressBar,
  },
  data() {
    return {
      select: '',
      scripts: '',
      items: [
        { name: 'Tax Inquiry', value: 'taxinquirytransactions' },
        { name: 'Payments', value: 'taxpayments' },
        { name: 'Tax Comments', value: 'taxcomments' },
        { name: 'Mobile Home', value: 'mobilehome' },
        { name: 'Tax Roll Adjustments', value: 'taxadjustment' },
        { name: 'Additional Payments', value: 'additionalPayments' },
        // { name: 'Import Penalty Start Date', value: 'fee' },
        { name: 'Import Unpaid fee', value: 'fee' },
        { name: 'Import Missing MH DECAL', value: 'import-mh-file' },
        { name: 'Import Penalty Start Date', value: 'import-penalty-date' },

      ],
      additionalScripts: [
        {
          name: 'Adjustment Before After Values', value: 'script-adjustment-values',
        },
        {
          name: 'Fix Fee Paid Status', value: 'update-fee-paid-status',
        },
        {
          name: 'MTG code and Situs Streets', value: 'script-mtg-street',
        },
        {
          name: 'Update Situs Address and Combined address', value: 'script-situs-address',
        },
        {
          name: 'Merge Payments for Other Fee', value: 'script-payment-merge',
        },
        {
          name: 'Update Null Fields to default 0', value: 'update-field-as-integer',
        },
        {
          name: 'Update Fee description', value: 'update-fee-dec',
        },
        {
          name: 'Update Total fee in taxinquiry', value: 'update-total-fee-taxinquiry',
        },
        {
          name: 'Insert Protest tax from temp-taxinquiry-collection', value: 'insert-protest-tax',
        },
        {
          name: 'Get Invoice number from adjustment comments', value: 'get-invoice-number-from-adjustment-comments',
        },
        {
          name: 'Import Invoice number from adjustment', value: 'add-invoice-number',
        },
        {
          name: 'Get Cert-number from adjustment only for TaxType(MHAJ)', value: 'get-certnumber-for-taxinquiry',
        },
        { // only tulsa needs it. So we are not adding it to taxInquiry import
          name: 'Populate Certificate numbers from MTG-code in Taxinquiry', value: 'get-cert-from-mtg-for-taxinquiry',
        },
        {
          name: 'Back page to certain shared Fund records', value: 'apply-back-page-to-shared-fund',
        },
        {
          name: 'Update the time stamp from Adjustment', value: 'adjustment-date-timestamp',
        },
        {
          name: 'Fix Owner Name In Care1', value: 'fix-owner-name',
        },
        {
          name: 'Delete all unpaid fee', value: 'delete-all-unpaidFee',
        },
        {
          name: 'Update decal data type', value: 'update-decal-data-type',
        },
        {
          name: 'Settle Negative Fees', value: 'settle-all-negative-fee',
        },
        {
          name: 'Move shared source sub-desc to desc', value: 'move-source-subdesc-desc',
        },
        {
          name: 'Update payment records loadmoretax', value: 'update-payment-records-load-more-tax',
        },
        {
          name: 'Update tax paid on taxinquiry', value: 'update-tax-paid-on-tax-inquiry',
        },
        {
          name: 'Update the missing tax-district in payments', value: 'update-the-missing-tax-district-in-tax-payments',
        },
        {
          name: 'Update the missing fee-number in payments', value: 'update-the-missing-fee-numbers-in-tax-payments',
        },
        {
          name: 'Update the missing tax-inquiry-id in tax-fees', value: 'update-the-missing-tax-inquiry-id-in-tax-fees',
        },
        {
          name: 'Update the missing fee number in tax-fees collection', value: 'update-the-missing-fee-number-in-tax-fees',
        },
        {
          name: 'Set Total Fees to Zero totalDue=0', value: 'settle-total-fee-to-zero',
        },
        {
          name: 'Payment Glitch for 25-06-2025', value: 'payment-glitch',
        },
        {
          name: 'Update taxinquiry in PTW', value: 'update-taxinquiry-in-ptw',
        },
        {
          name: 'Update owner name in payments', value: 'update-the-missing-owner-name-in-tax-payments',
        },
        {
          name: 'Fix missing adjustments', value: 'script-fix-tulsa-data',
        },
        {
          name: 'Fix tax roll summary', value: 'script-fix-tulsa-data-summary',
        },
        {
          name: 'Update datatype in taxcomments collection', value: 'update-datatype-in-taxcomments-collection',
        },
        {
          name: 'Load More Flag In Payments', value: 'fix-load-more-flag',
        },
        {
          name: 'Update only protest amount in Taxroll Summary', value: 'update-only-protest-amount-in-taxroll-summary',
        },
        {
          name: 'Update Datatype of certificate from string to number', value: 'convert-certificate-number-to-number',
        },
        {
          name: 'Delete indexes from collection before importing Legacy Data', value: 'delete-indexes-from-collection',
        },
        {
          name: 'Create indexes to collection after importing Legacy Data', value: 'create-indexes-to-collection',
        },
        {
          name: 'Update Datatype of addition(taxinquirytransaction, taxadditions)', value: 'convert-addition-number-to-string',
        },
        {
          name: 'Update Datatype of zip(taxinquirytransaction)', value: 'convert-zip-number-to-string',
        },
        {
          name: 'Import addition field to taxinquirytransactions', value: 'import-addition-field-to-tax-inquiry-transactions',
        },
        {
          name: 'Get MH Decal Issue Records Count', value: 'get-mh-decal-issue-records-count',
        },
        {
          name: 'Update Missing Receipt ', value: 'missing-receipt-numbers-in-tax-payments',
        },
        {
          name: 'Remove Decimal From Situs', value: 'remove-decimal-from-situs',
        },
        {
          name: 'Remove Decimal from Assessor', value: 'remove-decimal-from-assessor-file',
        },
        {
          name: 'Fixes Noble Mobile Home for 2025 & tax type P', value: 'fixes-noble-mobile-home-values',
        },
        {
          name: 'Copy Loan Number to New Tax Roll', value: 'copy-loan-number-to-new-taxroll',
        },
        {
          name: 'Copy deed bk or pg from temp.taxInquiry to taxInquiry collection', value: 'insert-deed-bk-or-pg-from-temp-tax-inquiry',
        },
        {
          name: 'Remove special characters from deed bk or pg in taxInquiry collection', value: 'remove-special-characters-from-deed-bk-or-pg',
        },
        {
          name: 'Move Tax Details from tax Payments ', value: 'move-tax-details-to-payment-details',
        },
        {
          name: 'Recover Deleted Fee', value: 'recover-deleted-fee',
        },
        {
          name: 'Reset isApportioned Flag (Lock bug fix)', value: 'reset-is-apportioned-flag',
        },
      ],
      isImporting: false,
      // Raised at click time. isImporting is only set once the server has answered (and is
      // then rewritten by the status polling), so it cannot stop a double click on its own.
      isStartingImport: false,
      isRunningScript: false,
      isThereAnError: false,
      totalImported: 0,
      importInterval: null,
      totalRecords: 0,
      writeConcern: false,
      scriptImport: '',
      hasSeenRunningImport: false,
      scriptResult: null,
      scriptError: '',
      gross: {
        taxYear: null,
        month: null,
      },
    };
  },
  computed: {
    // any click-started request still waiting on the server
    isBusy() {
      return this.isStartingImport || this.isRunningScript;
    },
    ...mapGetters('importStatus',
      ['getSelectedCollection', 'getSelectedScript']),
  },
  methods: {
    ...mapActions('importStatus', [
      'loadImportLargeFilesData',
      'updateSelectedCollectionInStore',
      'updateSelectedScriptInStore',
      'truncateTempCollection',
      'LegacyImport',
      'additionalScript',
      'scriptGrossAssessedUpdate',
    ]),
    handleSelectionChange() {
      this.updateSelectedCollectionInStore(this.select);
    },
    handleAdditionalScripts(script) {
      this.scriptImport = script;
      // this.updateSelectedScriptInStore(script);
    },
    resetScriptFeedback() {
      this.isThereAnError = false;
      this.scriptResult = null;
      this.scriptError = '';
      this.totalImported = 0;
      this.totalRecords = 0;
    },
    stopImportProgressPolling() {
      if (this.importInterval) {
        clearInterval(this.importInterval);
        this.importInterval = null;
      }
    },
    async ensureNoActiveImport() {
      const importDataStatus = await this.loadImportLargeFilesData();
      if (importDataStatus && importDataStatus.importingStatus) {
        this.$store.dispatch('flashWarn', 'Another import or script is already running.', { root: true });
        return false;
      }
      return true;
    },

    async sendCollectionValue() {
      if (this.isBusy) return;
      const collection = this.getSelectedCollection;

      if (!collection) {
        this.$store.dispatch('flashWarn', 'Please select a collection to import.', { root: true });
        return;
      }

      const writeConcernStatus = this.writeConcern === '1';
      const criteria = {
        collectionName: collection,
        addWriteConcern: writeConcernStatus,
      };
      this.isStartingImport = true;
      try {
        await this.LegacyImport({ criteria });
        this.isImporting = true;
        this.startImportProgressPolling();
      } finally {
        this.isStartingImport = false;
      }
    },
    async handleScript() {
      if (this.isBusy) return;
      const script = this.scriptImport;

      if (!script) {
        this.$store.dispatch('flashWarn', 'Please select a script to run.', { root: true });
        return;
      }

      // held from the click, before ensureNoActiveImport and the script request come back
      this.isRunningScript = true;
      try {
        if (script === 'move-tax-details-to-payment-details'
          || script === 'recover-deleted-fee') {
          await this.runMoveTaxDetailsScript(script);
          return;
        }

        const criteria = {
          collectionName: script,
        };
        await this.additionalScript({ criteria });
      } finally {
        this.isRunningScript = false;
      }
    },
    async runMoveTaxDetailsScript(script) {
      const canStartImport = await this.ensureNoActiveImport();

      if (!canStartImport) {
        return;
      }

      const criteria = {
        collectionName: script,
      };

      this.resetScriptFeedback();
      this.stopImportProgressPolling();
      this.isImporting = true;
      this.startImportProgressPolling({ waitForRunningStatus: true });

      try {
        const scriptResults = await this.additionalScript({ criteria });
        this.stopImportProgressPolling();

        if (!scriptResults) {
          return;
        }

        const {
          status, message, count, error,
        } = scriptResults;

        if (status) {
          this.scriptResult = {
            message,
            count,
          };
        } else {
          this.isThereAnError = true;
          this.scriptError = error || message || 'An error occurred while moving tax details.';
        }
      } catch (error) {
        this.stopImportProgressPolling();
        this.isThereAnError = true;
        this.scriptError = error.message || 'An error occurred while moving tax details.';
      } finally {
        this.isImporting = false;
      }
    },

    async truncateCollection() {
      const collection = this.getSelectedCollection;
      const item = { collectionName: collection };
      this.truncateTempCollection({ item });
    },

    startImportProgressPolling({ waitForRunningStatus = false } = {}) {
      this.stopImportProgressPolling();
      this.hasSeenRunningImport = false;
      this.importInterval = setInterval(async () => {
        const importDataStatus = await this.loadImportLargeFilesData();
        if (!importDataStatus) {
          return;
        }
        const {
          importedData, totalRecords, importingStatus, isThereAnError,
        } = importDataStatus;

        if (importingStatus) {
          this.hasSeenRunningImport = true;
        }

        this.isImporting = importingStatus;
        this.isThereAnError = isThereAnError;
        this.totalRecords = totalRecords || 0;
        this.totalImported = importedData || 0;

        if (isThereAnError) {
          this.isImporting = false;
          this.scriptError = this.scriptError || 'An error occurred during processing.';
          this.stopImportProgressPolling();
          return;
        }

        const isImportComplete = waitForRunningStatus
          ? this.hasSeenRunningImport && !importingStatus
          : ((!importingStatus) || (importedData === null) || (importedData >= totalRecords));

        if (isImportComplete) {
          this.isImporting = false;
          this.stopImportProgressPolling();
        }
      }, 2500);
    },
    updateGross() {
      const { taxYear, month } = this.gross;
      if (!taxYear || !month) {
        alert('Please enter both tax year and month');
        return;
      }
      const criteria = {
        taxYear,
        month,
      };
      this.scriptGrossAssessedUpdate({ criteria }).then(() => {
        alert('Gross updated successfully');
      })
        .catch((error) => {
          console.error('Error updating gross:', error);
          alert('Failed to update gross. Please try again.');
        });
    },
  },
  beforeDestroy() {
    this.stopImportProgressPolling();
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>
